/* global $ */
import React, { Component } from 'react'
import PropTypes from 'prop-types'

export class RangeSlider extends Component {
  componentDidMount () {
    const {
      min,
      max,
      step,
      grid_snap,
      grid,
      postfix,
      type,
      values,
      from
    } = this.props
    this.element = $(this.select).ionRangeSlider({
      type: type,
      min: min,
      max: max,
      step: step,
      grid_snap: grid_snap,
      grid: grid,
      postfix: postfix,
      values: values,
      from: from
    })
    this.handleChange = this.handleChange.bind(this)
    this.element.on('change', this.handleChange)
  }

  componentWillUnmount () {
    this.element.off('change', this.handleChange)
    this.element = this.element.ionRangeSlider('destroy')
  }

  // an input object would exist in props if the component is used by a Redux <Field> - if the component is
  // instantiated in any way other than a Redux <Field> it would have regular props

  handleChange (e) {
    if (this.props.input) {
      this.props.input.onChange(e.target.value)
      return
    }
    this.props.onChange(e.target.value)
  }

  render () {
    return (
      <input
        type='text'
        className='js-range-slider'
        ref={node => (this.select = node)}
        onChange={this.props.onChange}
      />
    )
  }
}

RangeSlider.propTypes = {
  input: PropTypes.any,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  grid: PropTypes.bool,
  grid_snap: PropTypes.bool,
  postfix: PropTypes.string,
  type: PropTypes.string,
  values: PropTypes.array,
  onChange: PropTypes.func,
  from: PropTypes.number
}

export default RangeSlider



// WEBPACK FOOTER //
// ./src/components/form/range-slider/index.js